export class Offcanvas {
    constructor() {
        this.toggleMenu = this.toggleMenu.bind(this);
        document.addEventListener('DOMContentLoaded', () => {
            const closeButton = document.querySelector('.close-btn');
            const menuToggle = document.querySelector('.menu-toggle');

            closeButton.addEventListener('click', this.toggleMenu);
            menuToggle.addEventListener('click', this.toggleMenu);
        });
    }

    toggleMenu() {
        const offcanvas = document.querySelector('.offcanvas');
        offcanvas.classList.toggle('open');
    }
}
